export const CommissionRuleActionTypes = {
  GET_COMMISSION_RULE_SUCCESS: undefined,
  GET_COMMISSION_RULE: undefined,
  SAVE_COMMISSION_RULE: undefined,
  COMMISSION_RULE_SAVED: undefined,
};
